import AnimateOnEnter from "@/ui/animations/AnimateOnEnter"
import CtaLink2 from "@/ui/atoms/CtaLink2"
import Typography from "@/ui/atoms/Typography"
import BlockContainer from "@/ui/structure/BlockContainer"
import { CtaData } from "@/ui/types/cta"
import { ReactNode } from "react"

export interface InfoBlockProps {
  title?: ReactNode
  message?: ReactNode
  cta?: CtaData
  decorations?: ReactNode[]
}

const InfoBlock = ({ title, message, cta, decorations }: InfoBlockProps) => {
  return (
    <div className="relative overflow-hidden">
      {decorations?.map((decoration, index) => (
        <AnimateOnEnter key={index} delay={250} animationType="fadeIn">
          <div className="absolute inset-0 pointer-events-none">
            {decoration}
          </div>
        </AnimateOnEnter>
      ))}
      <BlockContainer
        className="pt-8 sm:pt-32"
        noGuttersLg
        type="card"
        classes={{
          card: "pt-8 pb-32 px-container xl:p-16 xl:-mx-10 bg-secondary text-text !rounded-t-card !rounded-b-none",
        }}
        fluidLg
      >
        <div className="xl:max-w-[500px] z-[2] text-center xl:text-left">
          {title && (
            <Typography
              variant={["subtitle2", "h3"]}
              weight={"bold"}
              className="mb-4"
            >
              {title}
            </Typography>
          )}
          <div className="sm:pr-[10%] mt-6">
            {message && (
              <Typography variant={["body2", "body1"]}>{message}</Typography>
            )}
          </div>
          {cta && <CtaLink2 className="mt-8 xl:mt-16 font-[500]" {...cta} />}
        </div>
      </BlockContainer>
    </div>
  )
}

export default InfoBlock
